export default "__VITE_ASSET__eFHS7QdA__"